import scrollToElement from 'scroll-to-element';

const anchorLinks = document.querySelectorAll('.anchor-links li > a, .anchor');

anchorLinks?.forEach(link => {
  link.addEventListener('click', event => {
    const href = link.getAttribute('href');

    if (!href || !href.startsWith('#') || href === '#') return;

    event.preventDefault();

    const header = document.querySelector('.header');
    const headerHeight = header?.offsetHeight || 0;

    if (href === '#hero') {
      scrollToElement(document.body, {
        offset: 0,
        ease: 'inOutQuint',
        duration: 1000,
      });
      return;
    }

    const targetElement = document.querySelector(href);

    if (targetElement) {
      scrollToElement(targetElement, {
        offset: -headerHeight,
        ease: 'inOutQuint',
        duration: 1000,
      });
    } else {
      const scrollOffset = headerHeight;
      const pathParts = window.location.pathname.split('/');
      const langPrefix =
        pathParts[1] && pathParts[1].length === 2 ? `/${pathParts[1]}` : '';
      window.location.href = `${langPrefix}/${href}?offset=${scrollOffset}`;
    }
  });
});

document.addEventListener('DOMContentLoaded', () => {
  const fullHash = window.location.hash;
  if (!fullHash) return;

  const [hashOnly, queryString] = fullHash.split('?');
  const targetElement = document.querySelector(hashOnly);
  if (!targetElement) return;

  const params = new URLSearchParams(queryString || '');
  const offset = parseInt(params.get('offset') || '0', 10);

  scrollToElement(targetElement, {
    offset: -offset,
    ease: 'inOutQuint',
    duration: 1000,
  });

  const pathParts = window.location.pathname.split('/');
  const langPrefix =
    pathParts[1] && pathParts[1].length === 2 ? `/${pathParts[1]}` : '';
  history.replaceState(null, '', langPrefix + '/');
});

// <ul class="anchor-links">
//   <li class="menu-item">
//     <a href="#"></a>
//   </li>
// </ul>
